import { useEffect, useState } from 'react';
import UIIcon from 'UIComponents/icon/UIIcon';
import styled, { theme, useMediaQuery } from 'academy-common-lib/utils/Styling';
import DesktopCardMenu from './DesktopCardMenu';
import MobileCardMenu from './MobileCardMenu';
import { useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledMenuIcon = styled(UIIcon).withConfig({
  displayName: "CardMenuIcon__StyledMenuIcon",
  componentId: "bw3ys8-0"
})(["font-size:20px;border-radius:100%;width:26px;height:26px;display:flex !important;align-items:center;justify-content:center;padding-top:3px;cursor:", ";opacity:", ";color:", ";background:", ";"], ({
  $isDisabled
}) => $isDisabled ? 'auto' : 'pointer', ({
  $isDisabled
}) => $isDisabled ? 0.5 : 1, ({
  use
}) => use === 'on-dark' ? theme.colors.OLAF : theme.colors.EERIE, ({
  use
}) => use === 'on-dark' ? 'rgba(0, 0, 0, 0.3)' : 'none');
export const MenuIcon = ({
  use = 'on-dark',
  onClick,
  isDisabled = false
}) => /*#__PURE__*/_jsx(StyledMenuIcon, {
  $isDisabled: isDisabled,
  "aria-disabled": isDisabled,
  className: "card-menu-icon",
  "data-test-id": "card-menu-popover-button",
  name: "verticalMenu",
  onClick: onClick,
  use: use
});
const CardMenuIcon = props => {
  const {
    use = 'on-light',
    isDisabled = false
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const onIconClick = e => {
    e.preventDefault();
    if (!isDisabled) {
      setIsOpen(true);
    }
  };
  const {
    isMobile
  } = useMediaQuery();
  const Component = isMobile ? MobileCardMenu : DesktopCardMenu;
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);
  return /*#__PURE__*/_jsx("div", {
    onClick: e => e.stopPropagation(),
    children: /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      isOpen: isOpen,
      onOpenChange: setIsOpen,
      use: use,
      children: /*#__PURE__*/_jsx(MenuIcon, {
        isDisabled: isDisabled,
        onClick: onIconClick,
        use: use
      })
    }))
  });
};
export default CardMenuIcon;